import { Button, MenuItem, Select } from '@material-ui/core';
/* eslint-disable no-nested-ternary */
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowDropDown, Room, Search } from '@material-ui/icons';
import { Autocomplete, Skeleton } from '@material-ui/lab';
import {
  getBusinessesSectors,
  getContractTypes,
  getDegreeLevels,
} from '@webapps/business';
import {
  FormikTextField,
  PaginationNumbers,
  TextField,
  useAuth,
  useQuery,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { Form, Formik, useFormik } from 'formik';
import { useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import CardOffer from './CardOffer';

const Offers = ({ offers, scrollOffers, setScrollOffers, totalElements, size, page, setPage }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { params } = useRouter();

  const [idSector, setIdSector] = useState('');
  const [degreeLevel, setDegreeLevel] = useState('');
  const [contractType, setContractType] = useState('');
  const [contractLength, setContractLength] = useState(0);

  const { data: sectors = [], isLoading: sectorLoading } = useQuery(
    getBusinessesSectors,
    {
      key: 'allSectorsJobs',
    }
  );

  const { data: degreeLevels = [], isLoading: degreeLevelLoading } = useQuery(
    getDegreeLevels,
    {
      key: 'levels',
    }
  );

  const { data: contractTypes = [], isLoading: contratTypLoading } = useQuery(
    getContractTypes,
    {
      key: 'contractTypes',
    }
  );

  const searchIdSectors = (e) => {
    const newValue = e.target.value === 'all' ? '' : e.target.value;
    setIdSector(newValue);
    setPage(1);
  };

  const searchDegreeLevels = (e) => {
    const newValue = e.target.value === 'all' ? '' : e.target.value;
    setDegreeLevel(newValue);
    setPage(1);
  };

  const searchContractTypes = (e) => {
    const newValue = e.target.value === 'all' ? '' : e.target.value;
    setContractType(newValue);
    setPage(1);
  };

  const searchContractLength = (e) => {
    const newValue =
      e.target.value === 'all' ? 0 : parseInt(e.target.value, 10);
    setContractLength(newValue);
    setPage(1);
  };

  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setMobile(true);
    } else {
      setMobile(false);
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth < 768) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    });
  }, [setMobile]);

  const filteredOffres = useMemo(() => {
    return offers.filter((o) => {
      const sectorMatches = !idSector || (o.sector && o.sector.id === idSector);
      const degreeLevelMatches =
        !degreeLevel || (o.degreeLevel && o.degreeLevel.id === degreeLevel);
      const contractTypeMatches =
        !contractType || (o.contractType && o.contractType.id === contractType);
      const contractLengthMatches =
        !contractLength || o.contractLength === contractLength;
      return (
        sectorMatches &&
        degreeLevelMatches &&
        contractTypeMatches &&
        contractLengthMatches
      );
    });
  }, [offers, idSector, degreeLevel, contractType, contractLength]);


  const handleScroll = (e) => {
    if (scrollOffers) return;
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
    if (scrollPercentage >= 80) {
      setScrollOffers(true);
    }
  };

  return (
    <div className={classes.container}>
      <div className={cx(global.title, classes.title)}>
        Nos offres d'emplois
      </div>
      <div className={classes.formations}>
        <div className={classes.offersDiv}>
          <div
            className={css({
              display: 'flex',
              flexWrap: 'wrap',
              width: '100%',
              gap: '16px', // Ajuste l'espacement entre les éléments
              '@media (max-width: 1495px)': {
                gap: '8px',
                flexDirection: 'column',
              },
              '@media (max-width: 768px)': {
                flexDirection: 'column',
              },
            })}
          >
            <div
              className={css({
                display: 'flex',
                gap: '16px', // Espacement entre les champs à l'intérieur du conteneur
                width: '48%',
                '@media (max-width: 1495px)': {
                  gap: '8px',
                  width: '100%',
                  flex: '1 1 48%', // Chaque conteneur prend environ la moitié de l'espace en vue bureau
                },
                '@media (max-width: 768px)': {
                  width: '100%',
                  flex: '1 1 48%', // Chaque conteneur prend environ la moitié de l'espace en vue bureau

                  flexDirection: 'column', // Passer à une disposition en colonne pour les écrans étroits
                  width: '100%',
                },
              })}
            >
              <TextField
                fullWidth
                label="Niveau de diplôme"
                name="degreeLevels"
                placeholder="Tous"
                onChange={(e) => searchDegreeLevels(e)}
                select
                borderRadius={400}
              >
                <MenuItem value="all">Tous</MenuItem>
                {degreeLevels.map(({ id: idDeg, label }, index) => (
                  <MenuItem
                    key={index}
                    value={idDeg}
                    className={css({ color: '#152652 !important' })}
                  >
                    {label}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                fullWidth
                label="Domaines professionnels"
                name="idSector"
                placeholder="Tous"
                onChange={(e) => searchIdSectors(e)}
                select
                borderRadius={400}
              >
                <MenuItem value="all">Tous</MenuItem>
                {sectors.map(({ id: idSec, label }, index) => (
                  <MenuItem
                    key={index}
                    value={idSec}
                    className={css({ color: '#152652 !important' })}
                  >
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            <div
              className={css({
                display: 'flex',
                gap: '16px',
                width: '48%',
                '@media (max-width: 1495px)': {
                  gap: '8px',
                  width: '100%',
                  flex: '1 1 48%', // Chaque conteneur prend environ la moitié de l'espace en vue bureau
                },
                '@media (max-width: 768px)': {
                  width: '100%',
                  flex: '1 1 48%', // Chaque conteneur prend environ la moitié de l'espace en vue bureau
                  flexDirection: 'column',
                  width: '100%',
                },
              })}
            >
              <TextField
                fullWidth
                label="Type de contrat"
                name="contractType"
                onChange={(e) => searchContractTypes(e)}
                select
                value={contractTypes?.label}
                borderRadius={400}
              >
                <MenuItem value="all">Tous</MenuItem>
                {contractTypes.map(({ id: idContract, label }, index) => (
                  <MenuItem
                    key={index}
                    value={idContract}
                    className={css({ color: '#152652 !important' })}
                  >
                    {label}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                fullWidth
                label="Durée du contrat"
                name="contractLength"
                onChange={(e) => searchContractLength(e)}
                select
                value={sectors?.label}
                borderRadius={400}
              >
                <MenuItem value="all">Durée (en mois)</MenuItem>
                {Array.from({ length: 36 }, (_, index) => (
                  <MenuItem key={index} value={index + 1}>
                    {index + 1}
                  </MenuItem>
                ))}
              </TextField>
            </div>
          </div>
        </div>
      </div>
      {!offers?.length || !filteredOffres?.length ? (
        <div
          className={css({
            textAlign: 'center',
            color: '#5D75A8',
            padding: '20px',
          })}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <Grid
          container
          direction="column"
          className={css({
            backgroundColor: '#F3F7FF',
            marginTop: spacing(2),
            padding: spacing(2),
            borderRadius: 10,
            maxHeight: '312px',
            '@media only screen and (max-width: 768px)': {
              height: 'auto',
              overflowX: 'hidden',
              maxHeight: 'none',
            },
          })}
        >
          <div
            className={css({
              flexDirection: 'row',
              display: 'flex',
              gap: 16,
              paddingRight: filteredOffres?.length > 4 ? spacing(2) : 0,
              overflowX: 'hidden',
              flexWrap: 'wrap',
              '&::-webkit-scrollbar': {
                backgroundColor: '#F3F7FF',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#0060F9',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#C0D9FF',
              },
              '@media only screen and (max-width: 1280px)': {
                paddingRight: filteredOffres?.length > 2 ? spacing(2) : 0,
              },
              '@media only screen and (max-width: 768px)': { overflow: 'hidden', padding: 0 },
            })}
            onScroll={(e) => handleScroll(e)}
          >
            {filteredOffres?.map((item, index) => (
              <>
                <CardOffer
                  key={index}
                  address={item?.address}
                  contrat={item?.contractType}
                  item={item}
                  lastTimeView={item?.createdAt}
                  name={item?.job}
                  typeFormation={item?.degreeLevel}
                />
              </>
            ))}
          </div>
        </Grid>
      )}
      <div className={classes.pagination}>
        <PaginationNumbers
          onChange={(newPage) => setPage(newPage)}
          page={page}
          pageCount={size}
          totalCount={totalElements}
        />
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: spacing(2.5),
    marginBottom: 25,
    '@media screen and (max-width: 768px)': {
      marginBottom: 20,
    },
  },
  pagination: {
    '@media screen and (min-width: 768px)': {
      display: 'none',
    }
  },
  title: {
    borderLeft: '3px solid #0060F9',
    paddingLeft: 8,
    marginBottom: spacing(2),
    fontWeight: 600,
    width: '100%',
  },
  offersDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  formations: {
    display: 'flex',
    width: '100%',
  },
});

export default Offers;
